import CustomerRoutes from "../../apiRoutes/CustomerRoutes";
import publicRoutes from "../../apiRoutes/publicRoutes";
import { api } from "../ConsumeApiController";


/**
 * Enviar un ítem al carrito de compras (Backend)
 * @param {Object} itemData - Objeto con product_id, quantity, type, options
 */
export async function addItemToCart(itemData)
{
    try {
        const storedUuid = localStorage.getItem('cart_uuid');
        
        // Si existe, lo agregamos al payload que vamos a enviar al backend
        if (storedUuid) {
            itemData.cart_uuid = storedUuid;
        }

        const response = await api.post(CustomerRoutes.Commerce.Cart.AddItem, itemData);
        
        if (response.data && response.success) {
            localStorage.setItem('cart_uuid',response.data.cart_uuid);
            return { 
                success: true, 
                data: response.data, 
                message: response.message 
            };
        }
        else
        {
            return { 
                success: false, 
                message: response.message || 'No se pudo agregar al carrito.' 
            };
        }

    } catch (error) {
        console.error("Error addToCart:", error);
        
        // Manejo de errores (ej: 422 Validación, 400 Disponibilidad agotada)
        let errorMessage = 'Ocurrió un error de conexión.';
        
        if (error.response && error.response.data) {
            // Si el backend devuelve un mensaje de error específico
            errorMessage = error.response.data.message || errorMessage;
        }

        return { 
            success: false, 
            message: errorMessage 
        };
    }
}

/**
 * Obtener el carrito actual (Opcional, para refrescar la UI)
 */
export const getMyCart = async () => {
    try {
        const response = await api.get(CustomerRoutes.Commerce.Cart.GetAll);
        if (response.success) {
            return { success: true, data: response.data };
        }
        return { success: false, message: response.message };
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const removeCartItem = async (itemId) => {
    try {
        const url = CustomerRoutes.Commerce.Cart.RemoveItem(itemId);
        const response = await api.delete(url);
        return response;
    } catch (error) {
        console.error(error);
        return { success: false, message: 'Error eliminando item' };
    }
};

// Opcional: Si permites cambiar cantidad en el carrito
export const updateCartItemQty = async (itemId, quantity) => {
    try {
        const url = CustomerRoutes.Commerce.Cart.UpdateItemQuantity(itemId)
        const response = await api.put(url, { quantity });
        return response;
    } catch (error) {
        return { success: false, message: 'Error actualizando cantidad' };
    }
};


/**
 * Sincronizar el carrito de invitado con el del usuario recién logueado
 * Se debe llamar INMEDIATAMENTE después del login exitoso.
 */
export const syncGuestCart = async (guestUuid) => {
    if (!guestUuid) return; // Si no hay carrito invitado, no hacemos nada

    try {
        const response = await api.post(CustomerRoutes.Commerce.Cart.SyncGuest, { 
            guest_uuid: guestUuid 
        });

        if (response.success) {
            return { success: true, newUuid: response.data.cart_uuid };
        }
    } catch (error) {
        console.error("⚠️ Error sincronizando carritos:", error);
        // No es crítico bloquear el login por esto, pero lo logueamos
        return { success: false, message: error.message };
    }
};